import { Directive, inject, input } from "@angular/core";

import { AnalyticsService } from "@services";

@Directive({ selector: "[mnAnalyticsClick]", host: { "(click)": "onClick();" } })
export class AnalyticsClickDirective {
  private readonly anS = inject(AnalyticsService);

  public name = input.required<string>({ alias: "mnAnalyticsClick" });

  public onClick(): void {
    const name = this.name();
    if (!name) {
      return;
    }

    this.anS.client(name);
  }
}
